export default "__VITE_ASSET__Cq16Bsq8__"